import { useEffect, useState } from "react";
import sal from "sal.js";
import MainDemoBanner from "./MainDemoBanner";
import android from "../../public/images/home/android.svg";
import CategorySix from "../Category/CategorySix";
import Footersection from "../Category/Footersection";
import Image from "next/image";
import ServiceEleven from "../Services/Service-Eleven";
import TeamFour from "../Team/TeamFour";
import bannerboy from "../../public/images/home/homeimagetransparent.png";
import {
  CourseNames,
  SubjectNames,
  UniversityName,
  CountryNames,
  FAQData,
  ShowVideosData,
  CountryDreamData,
  getTestiMonials,
  getBlogs,
  getCoursesList,
} from "@/Action/api";
import GlobalAccordion from "@/components/Accordions/Global-Accordion";
import { useRouter } from "next/router";
import TeamOne from "../Team/TeamOne";
import Link from "next/link";
import { ASSETS_URL } from "@/Constant";
import {
  Target,
  GraduationCap,
  FileCheck,
  RefreshCw,
  Users,
  Plane,
} from "lucide-react";
const getTruncatedText = (htmlString, wordLimit = 10) => {
  // Create a temporary element to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // Get the plain text content
  const textContent = tempDiv.textContent || tempDiv.innerText || "";

  // Truncate to the specified number of words
  const words = textContent.trim().split(/\s+/);
  const truncated = words.slice(0, wordLimit).join(" ");

  return truncated;
};

const blogData = {
  blogTitle: "The Immigration Gurus Blog",
  description:
    "Expert insights, visa tips, success stories, and immigration news from trusted professionals.",
};

const studyAbroadSteps = [
  {
    title: "Considering Your Goals",
    description:
      "Starting from the free 1:1 counselling session, the Immigration guru ensures to understand your requirements and preferences related to career and goals.",
    disable: false,
    id: 1,
  },
  {
    title: "Preparing the Right Path",
    description:
      "From country to university selection, it all depends on your requirements and interests. We help you to shortlist the best fit for your study abroad dream.",
    disable: false,
    id: 2,
  },
  {
    title: "Handling Applications",
    description:
      "We help you apply to your preferred universities, helping with SOP, LORs, to document submission. Maintaining complete transparency makes us renowned study abroad consultants in India​.",
    disable: false,
    id: 3,
  },
  {
    title: "Focusing Offer Letter",
    description:
      "After getting the initial offer letter, we help you prepare for the documents and other processes to receive the most-awaited invitation letter.",
    disable: false,
    id: 4,
  },
  {
    title: "Visa Guidance",
    description:
      "Our best study abroad consultants in India allow students to prepare for visa paperwork, financials, and mock interviews to make you completely prepared.",
    disable: false,
    id: 5,
  },
  {
    title: "Get Ready to Fly",
    description:
      "From planning departure to last moment guidance, along with post-arrival services once reaching your destination, helps you gain a smooth transition into your dream life.",
    disable: false,
    id: 6,
  },
];

const websiteSections = [
  {
    header: "12+ Years of Experience",
    icon: "feather-heart",
    isPrimary: false,
    description:
      "Decade of Trusted Guidance, transforming study abroad dreams into reality",
  },
  {
    header: "2K+ Students Counselled",
    icon: "feather-book",
    isPrimary: true,
    description:
      "Providing expert guidance and personalization to provide real-time results",
  },
  {
    header: "100+ institutions tie ups",
    icon: "feather-monitor",
    isPrimary: false,
    description:
      "Strong tie-ups with top global universities provide global opportunities.",
  },
];

const MainDemo = () => {
  const [activeMenuItem, setActiveMenuItem] = useState("courses");
  const [courses, setCourses] = useState([]);
  const [subjects, setsubjects] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [universityData, setUniversityData] = useState([]);
  const [faqdata, setfaqdata] = useState();
  const [showvideos, setshowvideos] = useState();
  const [countrydream, setcountrydream] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [country, setCountry] = useState([]);
  const [testiMonials, setTestiMonials] = useState([]);
  const [blogsData, setBlogsData] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedcourses, setSelectedCourses] = useState("");
  const [selectedStudyLevel, setSelectedStudyLevel] = useState("");
  const [isUniversitySearchActive, setIsUniversitySearchActive] =
    useState(false);
  const [isStudyLevelActive, setIsStudyLevelActive] = useState(false);
  const [courseSearchQuery, setCourseSearchQuery] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const router = useRouter();

  const gradient1 =
    "linear-gradient(25deg, rgb(14, 20, 46) 50%, rgb(157, 86, 24) 100%)";
  const gradient2 =
    "linear-gradient(25deg, rgba(14, 20, 46, 1) 0%, rgba(16, 24, 113, 1) 100%)";

  const style = {
    // background: toggleBackground ? gradient1 : gradient2,

    background: gradient1,
    transition: "background 0.3s ease",
  };

  const toggleMenuItem = (item) => {
    setActiveMenuItem(item);
  };

  useEffect(() => {
    sal({
      threshold: 0.01,
      once: true,
    });
  }, []);

  const fetchUniversity = async () => {
    try {
      const result = await CourseNames();
      if (result?.res?.success === true) {
        const newMajorData = result?.res?.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        setCourses(newMajorData);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const Subjects = async () => {
    try {
      const result = await SubjectNames();
      if (result?.res?.success === true) {
        const options = result?.res?.data?.map((item) => ({
          id: item.id,
          // label: item.name,
          name: item.name,
          value: item.id,
        }));
        setsubjects(options);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchFAQData = async () => {
    try {
      const result = await FAQData();

      setfaqdata(result?.res || []);
    } catch (error) {
      console.error("Error fetching universities:", error);
    }
  };

  const fetchvideosData = async () => {
    try {
      const result = await ShowVideosData();

      setshowvideos(result?.res?.data || []);
    } catch (error) {
      console.error("Error fetching universities:", error);
    }
  };

  const CountryDreamDatashow = async () => {
    try {
      const result = await CountryDreamData();
      setcountrydream(result?.res?.data?.countries || []);
    } catch (error) {
      console.error("Error fetching universities:", error);
    }
  };

  const fetchUniversityData = async (search = "") => {
    try {
      const result = await UniversityName({ search });
      setUniversityData(result?.res?.data || []);
    } catch (error) {
      console.error("Error fetching universities:", error);
    }
  };

  useEffect(() => {
    if (searchQuery.length >= 3) {
      fetchUniversityData(searchQuery);
      setShowDropdown(true);
    } else {
      setUniversityData([]);
      setShowDropdown(false);
    }
  }, [searchQuery]);

  const fetchCourseOptions = async (search) => {
    try {
      const result = await getCoursesList({
        name: search,
        subjectid: selectedSubject ? [Number(selectedSubject)] : [],
        studylevel: selectedSubject ? [Number(selectedSubject)] : [],
        country: selectedStudyLevel ? [Number(selectedStudyLevel)] : [],
      });
      const payload = result?.res?.data;
      const list =
        payload?.Courses ||
        payload?.courses ||
        payload?.rows ||
        payload?.data ||
        (Array.isArray(payload) ? payload : []);
      setCourseOptions(
        list.map((item) => ({
          id: item.id,
          name: item.masterCourse || item.name,
          universityName: item?.university?.name,
          countryName: item?.country?.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching course options:", error);
      setCourseOptions([]);
    }
  };

  useEffect(() => {
    if (!showCourseDropdown) return;
    const handler = setTimeout(() => {
      fetchCourseOptions(courseSearchQuery);
    }, 300);
    return () => clearTimeout(handler);
  }, [courseSearchQuery, showCourseDropdown, selectedSubject, selectedStudyLevel]);

  const handleCourseInputChange = (e) => {
    const value = e.target.value;
    setCourseSearchQuery(value);
    setShowCourseDropdown(true);
    if (!value) setSelectedCourses("");
  };

  const handleCourseSelect = (item) => {
    setSelectedCourses(item.id);
    setCourseSearchQuery(item.name);
    setShowCourseDropdown(false);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setIsStudyLevelActive(false);
    setIsUniversitySearchActive(true);
    if (e.target.value.length >= 3) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleOptionClick = (name) => {
    setSearchQuery(name); // Set selected name in input
    setShowDropdown(false);
  };

  const handleStudyLevelChange = () => {
    setIsStudyLevelActive(true);
    setIsUniversitySearchActive(false);
  };

  const fetchCountry = async () => {
    try {
      const result = await CountryNames();
      if (result?.res?.success === true) {
        const newMajorData = result?.res?.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        setCountry(newMajorData);
      }
    } catch (error) {
      console.error("Error fetching country:", error);
    }
  };

  const fetChTestiMonials = async () => {
    try {
      const result = await getTestiMonials();
      if (result?.res?.success) {
        setTestiMonials(result?.res?.data?.story);
      }
    } catch (error) {
      console.error("Error fetching country:", error);
    }
  };

  const fetchBlogs = async () => {
    try {
      const result = await getBlogs();
      if (result?.res?.success) {
        setBlogsData(result?.res?.data);
      }
    } catch (error) {
      console.error("Error fetching country:", error);
    }
  };
  useEffect(() => {
    fetchUniversity();
    fetchCountry();
    Subjects();
    fetchFAQData();
    fetchvideosData();
    CountryDreamDatashow();
    fetChTestiMonials();
    fetchBlogs();
  }, []);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions || []);
  };

  // const handleSearchClick = async () => {
  //   const data = {
  //     subjectid:selectedStudyLevel ,
  //     studylevel:selectedSubject ,
  //     country: selectedcourses,
  //   };

  //   try {
  //     const result = await SearchCourse(data);
  //   } catch (error) {
  //     console.error("Error fetching course data:", error);
  //   }
  // };

  const handleSearchClick = async () => {
    const data = {
      subjectid: selectedcourses,
      studylevel: selectedSubject,
      country: selectedStudyLevel,
    };
    const queryParams = new URLSearchParams({
      studylevel: data.studylevel,
      country: data.country,
      q: courseSearchQuery,
    });
    if (courseSearchQuery) queryParams.set("q", courseSearchQuery);

    // window.location.href = `/study-courses?${queryParams}`;
    router.push(`/study-courses?${queryParams.toString()}`);
  };

  const handleSearchData = async () => {
    const data = {
      country: selectedcourses,
    };

    const queryParams = new URLSearchParams({
      country: data.country,
    });

    window.location.href = `/universitycollege?${queryParams}`;
  };

  return (
    <>
      <main className="rbt-main-wrapper">
        <div style={{ position: "relative", width: "100%", height: "800px" }}>

          {/* Video */}
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <source src="/HeroVideos/6.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.25)",
              zIndex: 1,
            }}
          />

          {/* Content */}
          <div
            style={{
              position: "relative",
              zIndex: 2,
              color: "white",
              fontSize: "30px",
            }}
            className="banner_padding"
          >
            <MainDemoBanner showImage={false} />
          </div>

        </div>

        <div
          style={{
            position: "relative",
          }}
        >

          <div
            className="container shadow_container"

          >
            <nav className="mainmenu-nav" style={{
              overflow: "auto",
            }}>
              <div className="mainmenu overlflow-auto d-flex gap-4">
                <div
                  className={`with-megamenu has-menu-child-item position-static cursor-pointer ${activeMenuItem === "courses" ? "open common_color" : ""
                    }`}
                  onClick={() => toggleMenuItem("courses")}
                >
                  <span className="cursorpoint">Courses</span>
                </div>
                <div
                  className={`with-megamenu has-menu-child-item position-static cursor-pointer ${activeMenuItem === "universities" ? "open common_color" : ""
                    }`}
                  onClick={() => toggleMenuItem("universities")}
                >
                  <span className="cursorpoint">Universities/Colleges</span>
                </div>
                <div
                  className={`with-megamenu has-menu-child-item position-static min-w-fit cursor-pointer ${activeMenuItem === "guide" ? "open common_color" : ""
                    }`}
                  onClick={() => toggleMenuItem("guide")}
                  style={{
                    minWidth: "fit-content",
                  }}
                >
                  <span className="cursorpoint">Guide me</span>
                </div>
              </div>
            </nav>

            <div className="row g-5 mt-2">
              {activeMenuItem === "courses" && (
                <form className="container my-4">
                  <div className="row g-3">
                    <div className="col-12 col-md-4 position-relative">
                      <input
                        type="text"
                        className="form-control"
                        style={{ fontSize: "16px" }}
                        placeholder="Select course subject (e.g., Law)"
                        value={courseSearchQuery}
                        onChange={handleCourseInputChange}
                        onFocus={() => setShowCourseDropdown(true)}
                        onBlur={() =>
                          setTimeout(() => setShowCourseDropdown(false), 200)
                        }
                      />
                      {showCourseDropdown && (
                        <ul className="dropdown-list">
                          {courseOptions.length > 0 ? (
                            courseOptions.map((data) => (
                              <li
                                key={data.id}
                                onMouseDown={() => handleCourseSelect(data)}
                                className="dropdown-item"
                              >
                                <div>{data.name}</div>
                                {(data.universityName || data.countryName) && (
                                  <small style={{ color: "#6b7385" }}>
                                    {data.universityName}
                                    {data.universityName && data.countryName
                                      ? " — "
                                      : ""}
                                    {data.countryName}
                                  </small>
                                )}
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item">No courses found</li>
                          )}
                        </ul>
                      )}
                    </div>

                    <div className="col-12 col-md-4">
                      <select
                        className="form-select"
                        style={{ fontSize: "16px" }}
                        value={selectedSubject}
                        onChange={(e) => setSelectedSubject(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select Study level
                        </option>
                        {subjects.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 col-md-4">
                      <select
                        className="form-select"
                        style={{ fontSize: "16px" }}
                        value={selectedStudyLevel}
                        onChange={(e) => setSelectedStudyLevel(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select a study Destination
                        </option>
                        {country.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </form>
              )}
              {/* Study Level Dropdown */}
              {activeMenuItem === "universities" && (
                <form action="#" className="rbt-search-style-1">
                  <div className="d-flex gap-5">
                    {/* <div className="col-lg-4 col-md-6 col-sm-12 position-relative">
                      <input
                        type="text"
                        placeholder="Search by university name"
                        onChange={handleSearchChange}
                        value={searchQuery}
                        className="form-control"
                        disabled={isStudyLevelActive}
                      />
                      {showDropdown && (
                        <ul className="dropdown-list">
                          {universityData.length > 0 ? (
                            universityData.map((item) => (
                              <li
                                key={item.id}
                                onClick={() => handleOptionClick(item.name)}
                                className="dropdown-item"
                              >
                                {item.name}
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item">No universities found</li>
                          )}
                        </ul>
                      )}
                    </div> */}

                    <div className="col-lg-4 col-md-6 col-sm-12">
                      {/* onChange={handleStudyLevelChange} */}
                      <select
                        className="form-select"
                        style={{ fontSize: "16px" }}
                        value={selectedcourses}
                        onChange={(e) => setSelectedCourses(e.target.value)}
                        disabled={isUniversitySearchActive}
                      >
                        <option value="" disabled selected>
                          Select study level
                        </option>
                        {country.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </form>
              )}
              {/* Study Destination Dropdown */}
              {activeMenuItem === "guide" && (
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <p>Let us help you with your search</p>
                </div>
              )}
            </div>

            <div className="d-flex mt-4 justify-content-end">
              <div className="read-more-btn">
                {activeMenuItem === "courses" && (
                  <div
                    className="rbt-btn rbt-switch-btn btn-gradient btn-sm cursor-pointer"
                    onClick={handleSearchClick}
                  >
                    <span data-text="Search">Search</span>
                  </div>
                )}
                {activeMenuItem === "universities" && (
                  <div
                    className="rbt-btn rbt-switch-btn btn-gradient btn-sm cursor-pointer"
                    onClick={handleSearchData}
                  >
                    <span data-text="Search">Search</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-team-area bg-color-extra2 pb--60 pt--60 ">
          <div className="container">
            <div className="row mb--60">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 className="title">About Immigration Guru's.</h2>
                  <p className="description has-medium-font-size mt--20">
                    The Immigration Guru’s: Get benefited from the best overseas
                    education consultants.
                  </p>
                </div>

                <div className="row  mt-2 pt">
                  {websiteSections.map((aboutData, index) => (
                    <div
                      className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mt--30"
                      key={aboutData.id}
                    >
                      <div className="rbt-counterup rbt-hover-03 ">
                        <div className="inner">
                          <div
                            className={`icon ${aboutData.isPrimary
                                ? "bg-primary-opacity"
                                : "bg-pink-opacity"
                              } p-3 w-fit`}
                            style={{
                              width: "fit-content",
                              borderRadius: "50%",
                            }}
                          >
                            <i
                              className={aboutData.icon}
                              style={{
                                fontSize: "40px",
                              }}
                            ></i>
                          </div>
                          <div className="">
                            <h4 className="title">{aboutData?.header}</h4>
                            <span className="subtitle">
                              {aboutData?.description}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-categories-area bg-color-white rbt-section-gapBottom pb--60 pt--60 ">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  {/* <span className="subtitle bg-primary-opacity">
                    CATEGORIES
                  </span> */}
                  <h2 className="title">Why choose Immigration Guru's</h2>
                </div>
              </div>
            </div>
            {/* splash design start */}
            <div
              className="rbt-splash-slider d-flex align-items-center"
              style={{
                padding: "0px",
                backgroundImage: "none",
                backgroundColor: "#fff",
              }}
            >
              <div className="container-fluid">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="splash-service-main position-relative">
                      <div className="service-wrapper service-white">
                        <div className="row g-0">
                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {/* <img src={android} alt="Android Icon" /> */}
                                {/* <Image
                                  src={android}
                                  width={50}
                                  height={50}
                                  priority={false}
                                  alt="Icons Images"
                                /> */}
                                {<Target size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">
                                  Career-First Guidance:
                                </h4>
                                <p>
                                  We focus on your career goals first, helping
                                  you choose the right study path for long-term
                                  success.
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {<GraduationCap size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">Right Course. Right University:</h4>
                                <p>
                                  We help you find the right course and
                                  university based on your profile, interests,
                                  and future career goals.
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {<FileCheck size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">
                                  Application-to-Visa Support:
                                </h4>
                                <p>
                                  From application preparation to visa filing, we
                                  provide complete guidance to help make your
                                  study abroad journey smoother.
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {<RefreshCw size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">
                                  Rejection? Let's Bounce Back:
                                </h4>
                                <p>
                                  We analyse your previous refusal, identify the
                                  gaps, and guide you with a stronger approach
                                  for your next application.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {<Users size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">
                                  Real Student. Real Experiences:
                                </h4>
                                <p>
                                  Connect with students who have already started
                                  their journey abroad and gain genuine insights
                                  from their experiences.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-xl-4 col-md-6 col-sm-6 col-12 service__style--column">
                            <div className="service service__style--1">
                              <div className="icon">
                                {<Plane size={50} color="white" />}
                              </div>
                              <div className="content">
                                <h4 className="title">
                                  Pre-Departure & Beyond:
                                </h4>
                                <p>
                                  Get the right guidance before you leave and
                                  continued support to help you settle
                                  confidently into your new journey.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Splash design end  */}
          </div>
        </div>
        <div className="rbt-categories-area bg-color-extra2 rbt-section-gapBottom pb--60 pt--60">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  {/* <span className="subtitle bg-primary-opacity">
                    CATEGORIES
                  </span> */}
                  <h2 className="title">
                    Top Courses to Choose for Study Abroad
                  </h2>
                </div>
              </div>
            </div>
            <div className="row g-5  ">
              <div className="row g-5 mobileviewpadding">
                <CategorySix />
              </div>
            </div>
          </div>
        </div>

        <div
          className="rbt-categories-area bg-color-[#0E142E] rbt-section-gapBottom pb--60 pt--60"
          style={style}
        >
          <div className="container">
            <div className="row g-5  ">
              <div
                className="service-wrapper  "
                style={{
                  background: "inherit",
                }}
              >
                <div className="container">
                  <div className="row mb--60">
                    <div className="col-lg-12">
                      <div className="section-title text-center">
                        <h2 className="title text-white">Dream Destinations</h2>
                        <p className="description has-medium-font-size mt--20 text-white">
                          Discover the ultimate study abroad locations where
                          academic excellence meets cultural immersion. These
                          dream destinations offer enriching learning
                          experiences and a chance to explore new horizons.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <ServiceEleven
                        isTitle={false}
                        countrydream={countrydream}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-team-area bg-color-white pb--60 pt--60 ">
          <div className="container">
            <div className="row mb--60">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 className="title">Steps to Your Dream Destination.</h2>
                </div>
              </div>
            </div>

            <div className="">
              <div className="row mt-4">
                <div className="d-none d-md-block col-md-5">
                  <div
                    className="pl-3 text-white"
                    style={{
                      backgroundImage: `url(${bannerboy.src})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      height: "100%",
                      transform: "scaleX(-1)",
                    }}
                  >
                    {/* Additional Content Placeholder */}
                  </div>
                </div>
                <div className="col-12 col-md-7">
                  <GlobalAccordion data={studyAbroadSteps} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-team-area bg-color-extra2 pb--60 pt--60 ">
          <div className="container">
            <div className="row mb--60">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 className="title">
                    Empowering Students, Transforming Futures.
                  </h2>
                  <p
                    className="description has-medium-font-size mt--20 justify-center"
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      justifyContent: "center",
                    }}
                  >
                    <span>
                      We guide Indian students to study abroad, offering support{" "}
                      <br />
                      and creating opportunities for a brighter future.{" "}
                      <Link href={"/testiomonials"} className="theme-gradient">
                        View More..
                      </Link>{" "}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <TeamOne TestiMonialsData={testiMonials} />
          </div>
        </div>
        <div className="rbt-team-area bg-color-white pb--60 pt--60 ">
          <div className="container">
            <div className="row mb--60">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 className="title">Hear From Our Experts.</h2>
                  <p className="description has-medium-font-size mt--20">
                    Our experts and institutions provide quick, clear answers to
                    your pressing questions in under 30 seconds.
                  </p>
                </div>
              </div>
            </div>
            <TeamFour isHead={false} showvideos={showvideos} />
          </div>
        </div>

        <div className="rbt-team-area bg-color-extra2 pb--60 pt--60 ">
          <div className="container">
            <div className="row mb--60">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <h2 className="title">Frequently Asked Questions(FAQ's).</h2>
                </div>
              </div>
            </div>
            <GlobalAccordion data={faqdata?.data ?? []} />
          </div>
        </div>

        {blogsData?.length > 0 && (
          <div className="rbt-team-area bg-color-white pb--60 pt--60 ">
            <div className="container">
              <div className="row mb--60">
                <div className="col-lg-12">
                  <div className="section-title text-center">
                    <h2 className="title">{blogData?.blogTitle}</h2>
                    <p className="description has-medium-font-size mt--20">
                      {blogData?.description}
                    </p>
                  </div>

                  <div className="row">
                    {blogsData?.map((item, index) => (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mt-4">
                        <div className="rbt-card variation-02 rbt-hover">
                          <div
                            className="rbt-card-img"
                            style={{
                              backgroundImage: `url(${ASSETS_URL}/uploads/blogs/${item?.id}/${item?.image?.src})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              height: "250px",
                              width: "100%",
                            }}
                          ></div>
                          <div className="rbt-card-body">
                            <h5 className="rbt-card-title">
                              <a href={`/blog-details/${item.slug}`}>
                                {item.title}
                              </a>
                            </h5>
                            <div
                              className="rbt-card-text"
                              dangerouslySetInnerHTML={{
                                __html: `
  <style>
    p {
      margin: 0 !important;
      padding: 0 !important;
      line-height: inherit !important;
    }
    span {
      color: inherit !important;
    }
    table {
      border-collapse: collapse !important;
      width: 100% !important;
      border: 2px solid #e6e3f1 !important;
      color: #6b7385 !important;
      font-family: Arial, sans-serif !important;
    }
    th, td {
      border: 1px solid #ddd !important;
      padding: 12px 16px !important;
      font-weight: 400 !important;
      text-align: left !important;
      color: #6b7385 !important;
      background-color: transparent !important;
    }
    thead {
      background-color: transparent !important;
    }
    th {
      font-weight: 600 !important;
      color: #6b7385 !important;
      width: 50% !important;
    }
    
  </style>
  ${getTruncatedText(item.discription)}
`,
                              }}
                            ></div>
                            <div className="rbt-card-bottom">
                              <a
                                className="transparent-button"
                                href={`/blog-details/${item.slug}`}
                              >
                                Learn More
                                <i>
                                  <svg
                                    width="17"
                                    height="12"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g
                                      stroke="#27374D"
                                      fill="none"
                                      fillRule="evenodd"
                                    >
                                      <path d="M10.614 0l5.629 5.629-5.63 5.629"></path>
                                      <path
                                        strokeLinecap="square"
                                        d="M.663 5.572h14.594"
                                      ></path>
                                    </g>
                                  </svg>
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* <TeamFour isHead={false} showvideos={showvideos} /> */}
            </div>
          </div>
        )}

        <div className="rbt-categories-area padding_bottom_60 pt--60" style={style}>
          <div className="container">
            <div className="row g-5  ">
              <div
                className="service-wrapper  bg-color-te"
                style={{
                  background: "inherit",
                }}
              >
                <Footersection />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MainDemo;
